import { render, staticRenderFns } from "./PageWrapper.vue?vue&type=template&id=0ad43412&scoped=true&"
import script from "./PageWrapper.vue?vue&type=script&lang=js&"
export * from "./PageWrapper.vue?vue&type=script&lang=js&"
import style0 from "./PageWrapper.vue?vue&type=style&index=0&id=0ad43412&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad43412",
  null
  
)

export default component.exports